import { PropsWithChildren } from 'react';

import { Box, Dialog, DialogContent } from '@evaneos/b2b-ui';

import { GradientBackground } from './GradientBackground';

type Props = PropsWithChildren<{
    open: boolean;
}>;

export function AT2GradientModalDialog({ open, children }: Props) {
    return (
        <Dialog
            open={open}
            maxWidth="xs"
            disableEscapeKeyDown
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 8,
                    },
                },
            }}
        >
            <DialogContent sx={{ padding: 0 }}>
                <GradientBackground>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        py={4}
                        px={3}
                        sx={{ width: '600px', maxWidth: '100%' }}
                    >
                        {children}
                    </Box>
                </GradientBackground>
            </DialogContent>
        </Dialog>
    );
}
